import React from "react";
import type { GridListProps } from "react-virtuoso";
import { useLGridistVirtualizedContext } from "./context";
import { GridVirtualizedBoxes, classes } from "./styles";

export const VirtuosoList = React.forwardRef(function VirtuosoList({ children, ...props }: GridListProps, ref) {
  const { List } = useLGridistVirtualizedContext();

  return (
    <GridVirtualizedBoxes {...props} {...List} ref={ref} className={classes.list}>
      {children}
    </GridVirtualizedBoxes>
  );
});
